// apps/api/src/qxcircle/qxcircle-follow-notification.ts
// Description: Local follow notification payload for QXCircle Slice 8/13.
// Owner: Masa Bayu
// Date: 2026-08-24

import type { QxCircleNotification } from "./qxcircle.types";

export function createFollowNotification(
  seq: number,
  authorName: string,
  authorHandle: string,
): QxCircleNotification {
  const handleSlug = authorHandle.replace(/^@/, "");
  return {
    id: `qxcircle_ntf_follow_${seq}`,
    kind: "follow",
    title: `Following ${authorName}`,
    body: "Local notification simulated — not production push.",
    href: `/qxcircle/profile/${encodeURIComponent(handleSlug)}`,
    read: false,
    createdAt: new Date().toISOString(),
  };
}
